import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../redux-store";
import useFeature from "../hooks/useFeature";
import { selectErrorToast } from "../ducks/app/error-toast/selectors";
import { errorToastDismissed } from "../ducks/app/error-toast";

// App-wide error toast, fed by createErrorReportingAsyncThunk and by the
// connection error status. Behind the
// "mobile-app-bottom-error-toast-instead-of-banner" feature it replaces the
// footer <ErrorMessages /> banner. It is positioned just above the bottom
// navigation, where that banner was, but is not part of the Footer: mounted
// at the app root, its z-index (1400) keeps it above dialog backdrops (1300).
const ErrorToast = () => {
  const enabled = useFeature("mobile-app-bottom-error-toast-instead-of-banner");
  const { messageKey } = useSelector(selectErrorToast);
  const { t } = useTranslation("translation");
  const dispatch = useAppDispatch();

  if (!enabled) {
    return null;
  }

  const onClose = (_e?: unknown, reason?: string) => {
    if (reason === "clickaway") return;
    dispatch(errorToastDismissed());
  };

  return (
    <Snackbar
      open={messageKey !== null}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{ bottom: "calc(env(safe-area-inset-bottom) + 78px) !important" }}
    >
      <Alert severity="error" variant="filled" onClose={onClose}>
        {messageKey && t(messageKey)}
      </Alert>
    </Snackbar>
  );
};

export default ErrorToast;
